import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from 'src/app/services/loading.service';
import { SnackService } from 'src/app/services/snack.service';
import { Observable } from 'rxjs';
import { _post, DeserializeVoid } from '../../../../base.service';

@Injectable({
  providedIn: 'root',
})
export class ProductionStockToPhysicalStockControllerRequestService {
  private static BASE_URL = '/signs/productionStockToPhysicalStock';
  private readonly post: <T>(
    path: string,
    body: RequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      ProductionStockToPhysicalStockControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public productionStockToPhysicalStock(
    signId: number,
    amountRoof: number,
    amountShelf: number
  ): Promise<void> {
    const requestBody: RequestBody = {
      signId: signId,
      amountRoof: amountRoof,
      amountShelf: amountShelf,
    };
    return this.post('', requestBody, DeserializeVoid).toPromise();
  }
}

interface RequestBody {
  signId: number;
  amountRoof: number;
  amountShelf: number;
}
